import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultComponent } from './default/default.component';
import { CustomComponent } from './custom/custom.component';
import { TemplatesComponent } from './templates/templates.component';
import { ColormapComponent } from './colormap.component';
import { FormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';

@NgModule({
  declarations: [DefaultComponent, CustomComponent, TemplatesComponent, ColormapComponent],
  imports: [CommonModule, FormsModule, ColorPickerModule],
  exports: [ColormapComponent],
})
export class ColormapModule {}
